module.exports = __webpack_public_path__ + "img/某百货公司损失销售额的预测.cd31d7c7.png";